module.exports = __webpack_public_path__ + "img/anquan.5f29f7a4.png";